export default class FormSubmit {
  /**
   * Create new form submit
   * @param {HTMLFormElement} form Form element
   */
  constructor (form) {
    this.isSubmitting = false

    form.addEventListener('submit', event => this.preventDuplicateSubmit(event))
  }

  /**
   * Prevent duplicate form submissions
   * @param {Event} event Submit event
   */
  preventDuplicateSubmit (event) {
    if (this.isSubmitting) {
      event.preventDefault()
    }

    this.isSubmitting = true
  }
}
